<section class="container-fluid">
  <ng-container
    *ngrxLet="{
      productsLoading: productsLoading$,
      totalProducts: totalProducts$,
      allProductsLoaded: allProductsLoaded$,
      isGridView: isGridView$,
      groupVariants: groupVariants$
    } as ctx"
  >
    <atx-infinite-scroll (scrolled)="onScroll()" [scrollTriggerPercentage]="1">
      <div class="grid-container" [class.grid-view]="ctx.isGridView">
        @if (!ctx.productsLoading && !loading) {
        <epc-recommendation-panel
          [location]="'PBasket'"
        ></epc-recommendation-panel>
        @if(mediaRelations) { @for (media of mediaRelations; track media) {
        <figure class="search-list-figure" [style]="{ order: media.position }">
          <atx-media-preview
            [media]="{
              url: media.mediaUrl,
              mediaType: media.mediaType
            }"
            [videoAttributes]="{
              autoplay: true,
              muted: true,
              controls: true,
              loop: true
            }"
            objectFit="cover"
          ></atx-media-preview>
          @if(media.properties?.url) {
          <a [href]="media.properties.url"></a>
          }
        </figure>
        } } } @if (products && !hideProducts) { @for (product of products; track
        product.productId; let i = $index) { @if(expandProductCardActive ||
        (!product.isAvailable && expandUnavailableProductActive)) {
        <epc-product-card-expand-container
          [ngStyle]="{ order: i + 1 }"
          (keepOpen)="closeAllExpandedProductCards()"
        >
          <epc-product-card
            atxInfiniteScrollItem
            [class.compact]="ctx.isGridView"
            [class.selected]="isSelected(i)"
            (cardClick)="clickedProductCard(product, i)"
            [clickDisabled]="!product.isAvailable"
            [product]="product"
            [prices]="product.priceRanges"
            [showActions]="showActions && product.isAvailable"
            [showIcons]="product.isAvailable"
            [showBookmarkIcon]="showBookmarkIcon"
            [showAsUnavailable]="!product.isAvailable"
            [compactView]="ctx.isGridView"
            [groupVariants]="ctx.groupVariants"
            [isSearchV2Enabled]="isSearchV2Enabled"
            [bookMarkNextAvailableVariant]="ctx.groupVariants"
            [showProductTitle]="false"
            [showFrameLabel]="false"
          >
          </epc-product-card>
          <atx-product-card-title
            header
            class="d-block px-2 pt-2"
            [product]="product"
            [titleFields]="titleFields$ | async"
          ></atx-product-card-title>
        </epc-product-card-expand-container>
        } @else { @if(selectedProductIndexes) {
        <epc-product-card
          atxInfiniteScrollItem
          [class.compact]="ctx.isGridView"
          [class.selected]="isSelected(i)"
          (cardClick)="clickedProductCard(product, i)"
          [product]="product"
          [prices]="product.priceRanges"
          [showActions]="showActions"
          [showBookmarkIcon]="showBookmarkIcon"
          [showAsUnavailable]="!product.isAvailable"
          [compactView]="ctx.isGridView"
          [groupVariants]="ctx.groupVariants"
          [isSearchV2Enabled]="isSearchV2Enabled"
          [bookMarkNextAvailableVariant]="ctx.groupVariants"
          [ngStyle]="{ order: i + 1 }"
        >
        </epc-product-card>
        } @else {
        <epc-product-card
          atxInfiniteScrollItem
          [class.compact]="ctx.isGridView"
          (cardClick)="clickedProductCard(product, i)"
          [clickDisabled]="!product.isAvailable"
          [product]="product"
          [prices]="product.priceRanges"
          [showActions]="showActions && product.isAvailable"
          [showIcons]="product.isAvailable"
          [showBookmarkIcon]="showBookmarkIcon"
          [showAsUnavailable]="!product.isAvailable"
          [compactView]="ctx.isGridView"
          [groupVariants]="ctx.groupVariants"
          [bookMarkNextAvailableVariant]="ctx.groupVariants"
          [isSearchV2Enabled]="isSearchV2Enabled"
          [ngStyle]="{ order: i + 1 }"
        >
        </epc-product-card>
        } } } } @if (ctx.productsLoading || loading) { @for (i of skeletons;
        track $index) {
        <epc-product-card-skeleton
          atxInfiniteScrollItem
          [class.compact-view]="ctx.isGridView"
        ></epc-product-card-skeleton>
        } }
      </div>
    </atx-infinite-scroll>
    @if(showPagination) {
    <atx-pagination-loader
      class="d-block mt-2 full-width"
      [allLoaded]="ctx.allProductsLoaded"
      [nonEmpty]="true"
      [total]="ctx.totalProducts"
      [loading]="ctx.productsLoading"
    ></atx-pagination-loader>
    }
  </ng-container>
</section>
